import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../helpers/util.service";

@Component({
  selector: 'idnow-front-face',
  templateUrl: './front-face.component.html',
  styleUrls: ['./front-face.component.css']
})
export class FrontFaceComponent implements OnInit {
  deviceChecked = {
    isDesktop: false,
    isMobile: false,
    isTablet: false,
    so: ''
  };
  constructor( private utilService: UtilService) {
    this.deviceChecked =  this.utilService.checkDevice();
  }

  ngOnInit() {
  }
}
